module.exports = __webpack_public_path__ + "img/result-detail-invest-outright01.96e3be4e.svg";